import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AppService } from '../../../../../../app.service';
import { RouterService } from '../../../../../../core/services/router.service';
import { CustomerI} from '../../../../interfaces/customer.interface';
import { Pager } from '../../../../interfaces/pager';
import { UserFind } from '../../../../interfaces/user-find';

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss']
})
export class CustomerSearchComponent implements OnInit {

  customers: CustomerI[] = null;
  suggestions: CustomerI[] = null;
  searchTimeout = null;

  constructor(public fb: FormBuilder, public app: AppService, public router: RouterService) {
  }

  customersDataSource = null;

  displayedColumns: string[] = [
    'icon',
    'name',
    'entry',
    'valid',
    'edit',
  ];

  columns = [
    {value: 'name', title: 'Name'},
    {value: 'external_id', title: 'Kdnr'},
    {value: 'external_claim_id', title: 'Zugangsnummer'},
    {value: 'any', title: 'Alle'},
  ];

  pager: Pager = {
    length: null,
    pageSize: 10,
    pageIndex: 0,
    sortCol: null,
    sortOrder: null
  };

  pageSizeOptions: number[] = [5, 10, 25, 100];

  public filterForm = this.fb.group({
    input: this.fb.control(''),
    column: this.fb.control('any'),
  });

  ngOnInit(): void {
    this.loadScopes();
    this.showLastSearch();
  }

  submit() {
    this.userFind();
  }

  showLastSearch(): void {
    this.app.storage.get('customers_last_search').then((params: UserFind) => {
      if (params) {
        this.filterForm.get('input').setValue(params.input);
        this.filterForm.get('column').setValue(params.column);
        this.pager = params.pager;
      }
    });

    if (this.app.customerSearchResults) {
      this.customers = this.app.customerSearchResults.found;
      this.pager.length = this.app.customerSearchResults.total;
      this.customersDataSource = new MatTableDataSource(this.customers);
    }
  }

  reset() {
    this.filterForm.get('input').setValue('');
    this.filterForm.get('column').setValue('any');
    this.customers = null;
    this.app.customerSearchResults = null;
  }

  liveSearch() {
    const values = this.filterForm.value;
    const inp = values.input;
    clearTimeout(this.searchTimeout);

    if(inp.length >= 4) {
      const params: UserFind = {input: inp, column: values.column, pager: this.pager};

      this.searchTimeout = setTimeout( () => {
        console.log('live');
        this.app.customersFind(params).then(data => {
          if(data.found && data.found.length) {
            this.suggestions = data.found;
          }
        });
      }, 850);
    } else {
      this.suggestions = null;
    }
  }

  closeSuggestions() {
    setTimeout(() => {
      this.suggestions = null;
    }, 500)
  }

  async userFind() {
    this.app.dialog.loader({
      title: 'Suche nach Benutzern'
    });
    const values = this.filterForm.value;
    const params: UserFind = {input: values.input, column: values.column, pager: this.pager};
    this.saveLastSearch(params);
    this.customers = await this.app.customersFind(params).then(data => {
      // console.log(data);
      this.app.dialog.closeLoader();
      this.pager.length = data.total;
      this.customersDataSource = new MatTableDataSource(data.found);
      return data.found;
    });
  }

  open(customer: CustomerI) {
    this.router.navigateByUrl('/admin/customers/edit/' + customer.id);
  }

  switchPage(e: PageEvent) {
    this.pager.pageIndex = e.pageIndex;
    this.pager.pageSize = e.pageSize;
    // console.log(e, this.pager);
    this.userFind();
  }

  sortResults(sort: any) {
    if(sort.active && sort.direction) {
      this.pager.sortCol = sort.active;
      this.pager.sortOrder = sort.direction;
      this.userFind();
    }
  }

  saveLastSearch(params: UserFind) {
    this.app.storage.set('customers_last_search', params);
  }

  loadScopes() {
    if (!this.app.scopes) {
      this.app.getScopes();
    }
  }

}
